module.exports = "/next-static/_next/static/images/testimonial_3_author-29b1c6f41fb4761105636528b444a4e2.png";